import { DocumentCategoryTagResponse } from "apis/data-contracts";
import { SearchIcon } from "assets/icons";
import Board from "components/Common/Board/Board";
import { Table } from "components/Common/Table/Table";
import TableInputMobile from "components/Common/Table/TableInputMobile";
import Button from "components/foundation/Button";
import { ROUTER_PATH } from "config/path";
import useTagsAutoCompleteQuery from "features/tag/hooks/queries/useTagsAutoCompleteQuery";
import React from "react";
import { useFormContext } from "react-hook-form";
import { Link, useNavigate } from "react-router-dom";
import styled from "styled-components";
import { TagDashboardFormData } from "..";
import SearchEmpty from "components/Common/Empty/SearchEmpty";
import { useDocumentClassesByCategoryQuery } from "features/document/hooks/queries/useDocumentClassesByCategoryQuery";

interface TagDashboardMobilePageProps {
  tags: DocumentCategoryTagResponse[];
}

const TagDashboardMobilePage = ({ tags }: TagDashboardMobilePageProps) => {
  const navigate = useNavigate();
  const { watch } = useFormContext<TagDashboardFormData>();

  const { data: autoCompleteData } = useTagsAutoCompleteQuery({
    searchTerm: watch("search"),
  });

  //ARCHIEVE 문서구분태그 조회
  const { data: documentClasses } = useDocumentClassesByCategoryQuery(
    tags[2].documentCategoryUuid,
  );

  const filteredTags = tags.filter(
    (tag) =>
      tag.tagCategories?.[0]?.tags?.length ||
      tag.tagCategories?.[1]?.tags?.length,
  );

  return (
    <TagDashboardMobilePageLayout>
      <Table.Header>
        <Table.TotalCount>총 {filteredTags.length}건</Table.TotalCount>

        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: "1rem",
          }}
        >
          <TableInputMobile
            autocomplete={autoCompleteData?.data.result.map((i) => ({
              label: i,
              value: i,
            }))}
          >
            <SearchIcon />
            검색
          </TableInputMobile>
          <Link to={ROUTER_PATH.tag.create}>
            <Button size="small">법인명 등록</Button>
          </Link>
        </div>
      </Table.Header>
      {filteredTags.length === 0 ? (
        <SearchEmpty />
      ) : (
        <Table.Layout>
          <Table.Table columns="auto 1fr 1fr 1fr" width="100%">
            <Table.Thead>
              <Table.Th>문서종류</Table.Th>
              <Table.Th>태그 #01</Table.Th>
              <Table.Th>태그 #02</Table.Th>
              <Table.Th>태그 #03</Table.Th>
            </Table.Thead>
            <Table.Tbody>
              {filteredTags.map((tag) => {
                return (
                  <Table.Tr
                    key={tag.documentCategoryUuid}
                    style={{
                      cursor: "pointer",
                    }}
                    onClick={() => {
                      navigate(
                        ROUTER_PATH.tag.dashboard.detail._path(
                          tag.documentCategoryUuid,
                        ),
                      );
                    }}
                  >
                    <Table.Td>{tag.documentCategoryName}</Table.Td>
                    <Table.Td>
                      {tag.documentCategoryName === "ARCHIVES"
                        ? documentClasses?.map((i) => i.name).join(", ")
                        : tag.tagCategories?.[0]?.tags
                            .map((i) => i.tagName)
                            .join(", ")}
                    </Table.Td>
                    <Table.Td>
                      {tag.documentCategoryName === "ARCHIVES"
                        ? tag.tagCategories?.[0]?.tags
                            .map((i) => i.tagName)
                            .join(", ")
                        : tag.tagCategories?.[1]?.tags
                            .map((i) => i.tagName)
                            .join(", ")}
                    </Table.Td>
                    <Table.Td>
                      {tag.documentCategoryName === "ARCHIVES"
                        ? tag.tagCategories?.[1]?.tags
                            .map((i) => i.tagName)
                            .join(", ")
                        : tag.tagCategories?.[2]?.tags
                            .map((i) => i.tagName)
                            .join(", ")}
                    </Table.Td>
                  </Table.Tr>
                );
              })}
            </Table.Tbody>
          </Table.Table>
        </Table.Layout>
      )}
    </TagDashboardMobilePageLayout>
  );
};

export default TagDashboardMobilePage;

const TagDashboardMobilePageLayout = styled(Board)`
  padding: 2rem 1.6rem;
  display: flex;
  flex-direction: column;
  gap: 2rem;
`;
